var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoudSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.198.75c.287.14.469.431.469.75v15a.833.833 0 01-1.349.655l-5.076-3.988H1.5a.833.833 0 01-.833-.834V5.667c0-.46.373-.834.833-.834h2.742L9.318.845a.833.833 0 01.88-.094zM9 3.216L5.045 6.322a.833.833 0 01-.515.178H2.333v5H4.53c.187 0 .368.063.515.178L9 14.785V3.215zm4.41.196a.833.833 0 011.18 0l.285.286a7.5 7.5 0 010 10.606l-.286.286a.834.834 0 01-1.178-1.178l.286-.286a5.833 5.833 0 000-8.25l-.286-.286a.833.833 0 010-1.178zm-1.666 2.5a.833.833 0 011.179 0l.143.143a4.167 4.167 0 010 5.892l-.143.143a.833.833 0 01-1.179-1.178l.143-.143a2.5 2.5 0 000-3.536l-.143-.143a.833.833 0 010-1.178z",
    fill: "#111"
  })));
}

export default SvgLoudSmall;